import { PropsWithChildren, ReactElement, useRef } from 'react';
import { useSelector } from 'react-redux';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { useContentHeight } from 'hooks/useContentHeight';
import { getAllLsBets } from 'store/selectors/betslip';

type TBetslipRootContainerProps = PropsWithChildren & {
  isHeightFixed?: boolean;
  detectTopHeight?: number;
};

export const BetslipRootContainer = ({
  children,
  isHeightFixed,
  detectTopHeight
}: TBetslipRootContainerProps): ReactElement => {
  const betslipContainerRef = useRef<HTMLDivElement | null>(null);
  const allLsBetsCount = useSelector(getAllLsBets).length;

  const wrapperHeight = useContentHeight(
    false,
    !isMobile() && detectTopHeight ? detectTopHeight : undefined
  );

  const isBetslipEmpty = allLsBetsCount === 0;
  const isScrollOnPage =
    SpringConfigs.HOORY_ENABLED &&
    SpringConfigs.HOORY_ENABLED_SPORTSBOOK_BETSLIP &&
    !isMobile();

  return (
    <div
      id="betslip-wrapper"
      data-id="betslip-root-container"
      className={cc([
        {
          'betslip__wrapper-fixed-height': isHeightFixed,
          scrollOnPage: isScrollOnPage
        }
      ])}
    >
      <div
        style={{
          maxHeight: wrapperHeight,
          height:
            !betslipContainerRef.current?.closest('.sportsbookWrapper') &&
            isHeightFixed
              ? wrapperHeight
              : '100%'
        }}
        className={cc([
          'betslipWrapper',
          {
            'betslipWrapper--empty': isBetslipEmpty,
            'betslipWrapper--scrollOnPage': isScrollOnPage
          }
        ])}
        ref={betslipContainerRef}
      >
        {children}
      </div>
    </div>
  );
};
